<template>
  <b-modal
    id="maintenance_form_modal"
    @show="onShow"
    @hide="onClose"
    @hidden="resetDataModal"
    centered
    hide-header
    no-close-on-esc
    no-close-on-backdrop
    scrollable
    size="lg"
  >
    <p class="h3 text-capitalize filterTittle">Maintenance Form</p>
    <hr />

    <div class="form-container">
      <build-form
        :template-id="templateId"
        :service-order-id="serviceOrderId"
        @submit="onSubmit()"
        @validated="onValidated()"
      />
    </div>

    <template #modal-footer="{ close }">
      <b-button variant="danger" size="sm" @click="close()">
        {{ $t("close") }}
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import { BModal } from "bootstrap-vue";
import vSelect from "vue-select";
import { getCurrentInstance, nextTick } from "@vue/composition-api";
import { useToast } from "vue-toastification/composition";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import BuildForm from "@/components/BuildForm";

export default {
  props: {
    formId: Number | String,
    templateId: Number | String,
    serviceOrderId: Number | String,
  },
  components: {
    BModal,
    vSelect,
    BuildForm,
  },
  emits: ["submit-form-validated"],
  setup(_, { emit }) {
    const vm = getCurrentInstance().proxy;
    const toast = useToast();

    const onShow = () => {};
    const onClose = () => {};
    const resetDataModal = () => {};

    const onSubmit = () => {
      emit("onSubmitFormBooklet");
      toast({
        component: ToastificationContent,
        props: {
          title: "Form OK",
          icon: "CheckIcon",
          variant: "success",
        },
      });
    };

    const onValidated = () => {
      emit("onFormValidated");
      toast({
        component: ToastificationContent,
        props: {
          title: "Form Validated",
          icon: "CheckIcon",
          variant: "success",
        },
      });
    };

    return {
      onShow,
      onClose,
      resetDataModal,
      onSubmit,
      onValidated,
    };
  },
};
</script>

<style lang="scss">
.form-container {
  max-height: 500px;
  overflow: auto;
}

.dark-layout {
  .filterTittle {
    color: white;
  }
  .formulate-input input {
    color: #fff !important;
    color-scheme: dark;
  }
  .formulate-input-wrapper {
    .vs__dropdown-toggle {
      background-color: transparent !important;
    }
  }
}
</style>
